import { render, staticRenderFns } from "./GiftCardContent.vue?vue&type=template&id=f9c9bbfe"
import script from "./GiftCardContent.vue?vue&type=script&lang=js"
export * from "./GiftCardContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports